module.exports = __webpack_public_path__ + "static/media/bg.00546390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 674
// module chunks = 0